module.exports = __webpack_public_path__ + "static/media/IRWIN-3mo-dashboard.7ec2073e.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/IRWIN-3mo-dashboard.PNG
// module id = 2670
// module chunks = 0